module.exports = __webpack_public_path__ + "img/location-tip.05517b64.jpg";